module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "weui_tab"
  }, [_vm._t("header"), _vm._v(" "), _c('div', {
    ref: "viewBoxBody",
    staticClass: "weui_tab_bd vux-fix-safari-overflow-scrolling"
  }, [_vm._t("default")], 2), _vm._v(" "), _vm._t("bottom")], 2)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/.10.3.0@vue-loader/lib/template-compiler.js?id=data-v-2072b210!./~/.1.0.35@vux-loader/src/template-loader.js!./~/.10.3.0@vue-loader/lib/selector.js?type=template&index=0!./~/.2.0.17@vux/src/components/view-box/index.vue
// module id = 271
// module chunks = 2